import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const TableFoot = ({ count, total, filter, setFilter }) => {
    const pageCount = Math.max(1, Number(count) || 1);
    const from = total ? (filter.page - 1) * filter.limit + 1 : 0;
    const to = total ? Math.min(filter.page * filter.limit, total) : 0;

    return (
        <div className="table-footer">
            <div className='table-limiter'>
                <span>Per Page:</span>
                <select
                    className='form-control'
                    style={{ maxWidth: "80px" }}
                    value={filter.limit}
                    aria-label="Rows per page"
                    // Parsed to a number so it matches the option values and
                    // the select keeps showing the current selection.
                    onChange={(e) => setFilter({ limit: Number(e.target.value) })}
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                {total > 0 && <span className="table-range">{from}–{to} of {total}</span>}
            </div>
            <Stack spacing={2}>
                <Pagination
                    showFirstButton
                    showLastButton
                    page={filter.page}
                    // MUI passes the target page as the second argument. The
                    // old handler read `e.target.innerText` instead, so the
                    // next/prev/first/last arrows — which have no text —
                    // requested `page=` and returned nothing.
                    onChange={(event, page) => setFilter({ page })}
                    count={pageCount}
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                />
            </Stack>
        </div>
    )
}

export default TableFoot
